import { Icons } from "./iconsRegistry";

const Icon = ({ name, size = 24, alt = "", ...props }) => {
  const src = Icons[name];
  if (!src) return null;
  return (
    <img
      src={src}
      alt={alt || name}
      width={size}
      height={size}
      style={{ display: "inline-block", pointerEvents: "none" }}
      {...props}
    />
  );
};

export default Icon;
